import { useAuth } from "../contexts/AuthContext";
import { Link, Navigate } from "react-router-dom";
import { Mail, IdCard, LogOut, Ticket, History, Settings as SettingsIcon } from "lucide-react";
import { Button } from "../components/ui/button";
import ChangePasswordCard from "../components/ChangePasswordCard";

export default function Profile() {
  const { role, user, logout, loading } = useAuth();

  if (loading) return <div className="container mx-auto py-16 text-center text-subtle">Chargement…</div>;
  if (role !== "client") return <Navigate to="/" replace />;

  return (
    <div className="container mx-auto px-4 md:px-8 py-10 max-w-2xl" data-testid="visitor-profile-page">
      <p className="overline mb-2">Mon compte</p>
      <h1 className="font-display text-4xl font-black tracking-tighter text-ink">Mon profil</h1>
      <p className="mt-2 text-subtle">Informations personnelles associées à votre compte BypassGo.</p>

      <div className="mt-8 border border-border divide-y divide-border" data-testid="profile-card">
        <Row icon={<IdCard size={18} />} label="Prénom" value={user?.prenom} testid="profile-prenom" />
        <Row icon={<IdCard size={18} />} label="Nom" value={user?.nom} testid="profile-nom" />
        <Row icon={<Mail size={18} />} label="Email" value={user?.email} testid="profile-email" />
      </div>

      {/* Spec utilisateur Feb 2026 — bloc « Changer mon mot de passe »
         disponible pour tous les comptes (visiteur ET admin, qui partagent
         la collection `users`). Email de confirmation envoyé après succès. */}
      <div className="mt-8">
        <ChangePasswordCard endpoint="/auth/change-password" testIdPrefix="visitor-change-password" />
      </div>

      <p className="overline mt-10 mb-3">Raccourcis</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <LinkCard to="/my-ticket" icon={<Ticket size={16} />} label="Mon ticket en cours" />
        <LinkCard to="/my-tickets" icon={<History size={16} />} label="Historique des tickets" />
        <LinkCard to="/settings" icon={<SettingsIcon size={16} />} label="Préférences" />
      </div>

      <div className="mt-10 pt-6 border-t border-border">
        <Button onClick={logout} variant="outline" className="border border-ink text-ink hover:bg-ink hover:text-white rounded-md h-12 px-6" data-testid="profile-logout-btn">
          <LogOut size={16} className="mr-2" /> Se déconnecter
        </Button>
      </div>
    </div>
  );
}

function Row({ icon, label, value, testid }) {
  return (
    <div className="flex items-start gap-4 p-4" data-testid={testid}>
      <div className="h-9 w-9 flex items-center justify-center bg-surface text-subtle shrink-0">{icon}</div>
      <div className="flex-1 min-w-0">
        <p className="text-xs uppercase tracking-wider text-subtle font-bold">{label}</p>
        <p className="mt-0.5 text-ink font-medium break-words">{value || <span className="text-subtle italic">Non renseigné</span>}</p>
      </div>
    </div>
  );
}

function LinkCard({ to, icon, label }) {
  return (
    <Link to={to} className="border border-border p-4 flex items-center gap-3 hover:border-ink transition-colors" data-testid={`profile-link-${to.replace(/\//g, "-")}`}>
      <div className="h-8 w-8 flex items-center justify-center bg-brand text-white">{icon}</div>
      <span className="font-medium text-ink">{label}</span>
    </Link>
  );
}
